import { cn } from "@/utils/cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-4xl bg-gray-300 dark:bg-gray-650",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
